import React, { useCallback, useEffect, useState } from "react";
import { map } from "ramda";

import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";
import IpOverrideListItem from "./IpOverrideListItem";
import { notBlank } from "../../util/ext";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "white",
  },
}));

const ApplicationAccountList = ({ overrides, selected, onDeleteItemClick }) => {
  const [currentOverride, setCurrentOverride] = useState({});
  const classes = useStyles();

  useEffect(() => {
    if (notBlank(selected)) {
      setCurrentOverride(selected);
    }
  }, [selected]);

  const handleRowSelected = useCallback(override => {
    setCurrentOverride(override);
  }, []);

  return (
    <List classes={{ root: classes.root }}>
      {map(override => {
        console.log(currentOverride);
        const isSelected =
          override.regionIpOverrideId === currentOverride.regionIpOverrideId ||
          override.ipAddressAsString === currentOverride.ipAddressAsString;
        return (
          <IpOverrideListItem
            key={override.regionIpOverrideId}
            override={override}
            selected={isSelected}
            onSelect={handleRowSelected}
            onDeleteClick={onDeleteItemClick}
          />
        );
      }, overrides)}
    </List>
  );
};

export default ApplicationAccountList;
